import { HTTPResponse, IPaginationResponse } from "services/http/http.types"
import { IProjectRole } from "./projectRoles.types"
import http, { handleHttpError, handleHttpResponse } from "services/http"


export interface IGetProjectRolesParams {
  nextPage?: string
  limit?: number
}

const getList = async (params: IGetProjectRolesParams): Promise<HTTPResponse<IPaginationResponse<IProjectRole>>> => {
  return http.get('/nsi/v1/project-roles', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const getOne = async (id: IProjectRole['id']): Promise<HTTPResponse<IProjectRole>> => {
  return http.post(`/nsi/v1/project-roles/` + id).then(handleHttpResponse).catch(handleHttpError)
}


const create = async (dto: Pick<IProjectRole, 'title' | 'description'>): Promise<HTTPResponse<IProjectRole>> => {
  return http.post('/nsi/v1/project-roles', dto).then(handleHttpResponse).catch(handleHttpError)
}

const update = async (dto: Partial<IProjectRole>, id: IProjectRole['id']): Promise<HTTPResponse<IProjectRole>> => {
  return http
    .patch('/nsi/v1/project-roles/' + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const projectRolesApi = {
  getList,
  getOne,
  create,
  update
}

export default projectRolesApi